import React, { useState, useLayoutEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Typography, Tooltip, Box } from '@material-ui/core'
import HandicapIconsList from 'components/molecules/HandicapIconsList'
import pictoAccessLogoSrc from 'assets/images/pictoaccess-logo.png'
import Link from '../../atoms/Link'
import useWindowSize from '../../../hooks/useWindowSize'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  bottomContainer: ({ isTooFlat }) => ({
    display: isTooFlat ? 'none' : 'flex',
    width: '100%',
    zIndex: 100,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down(390)]: {
      marginTop: theme.spacing(1),
    },
  }),
  pictoLogo: ({ isSmall }) => ({
    bottom: 0,
    width: isSmall ? '40vw' : '30vw',
    marginRight: '1vw',
  }),
  linkLabel: ({ isSmall, isTooFlat }) => ({
    display: isTooFlat ? 'none' : 'block',
    textDecoration: 'none',
    marginLeft: '1vw',
    color: theme.palette.common.black,
    fontSize: isSmall ? '4.5vw' : '3.4vw',
    fontWeight: 800,
    borderBottom: '3px solid black',
  }),
  separator: {
    flex: 1,
  },
  pictoLogoLink: { paddingBottom: 0, marginBottom: 0 },
  pictoLogoIfTooFlat: ({ hover }) => ({
    opacity: hover ? 0.3 : 1,
    transition: 'opacity 0.3s',
    position: 'absolute',
    bottom: 0,
    right: 0,
    marginBottom: 0,
    padding: '2vw 1vw 1vw 2vw',
    backgroundColor: 'white',
    borderRadius: '2vw 0 0 0',
    width: '20vw',
  }),
}))

const pictoAccessLogo = () => {
  let logo = (logo = pictoAccessLogoSrc)
  if (process.env.NODE_ENV !== 'development') {
    const { widgetUrl } = document.querySelector('body').dataset
    logo = `${widgetUrl}${pictoAccessLogoSrc}`
  }
  return logo
}

const AccessibilityWidget = (props) => {
  const { handicaps, cardUrl } = props
  const [hover, setHover] = useState(false)
  const { width, height, ratio } = useWindowSize()
  const isSmall = width * height < 130000
  const isTooFlat = ratio > 2.7
  const classes = useStyles({ hover, isSmall, isTooFlat })
  const [imgPicto, setImgPicto] = useState(null)

  useLayoutEffect(() => {
    setImgPicto(pictoAccessLogo())
  }, [imgPicto])

  return (
    <Box
      tabIndex="-1"
      className={classes.root}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => window.open(cardUrl)}
    >
      <HandicapIconsList handicaps={handicaps} />
      <Box className={classes.bottomContainer}>
        <Tooltip title="Consulter plus d'informations concernant l'accessibilité avec Picto Access">
          <Typography
            href={cardUrl}
            target="_blank"
            gutterBottom={false}
            variant="h4"
            component="a"
            className={classes.linkLabel}
            onClick={(e) => e.preventDefault()}
          >
            En savoir plus
          </Typography>
        </Tooltip>
        <div className={classes.separator} />
        <Link
          className={classes.pictoLogoLink}
          href={cardUrl}
          target="_blank"
          onClick={(e) => e.preventDefault()}
          title="Lien vers la page de l'établissement sur Picto Access (Ouvre un nouvel onglet)"
        >
          {imgPicto && (
            <img
              className={classes.pictoLogo}
              src={imgPicto}
              alt="Picto Access"
            />
          )}
        </Link>
      </Box>
      {isTooFlat && (
        <Link
          href={cardUrl}
          target="_blank"
          onClick={(e) => e.preventDefault()}
          title="Lien vers la page de l'établissement sur Picto Access (Ouvre un nouvel onglet)"
        >
          {imgPicto && (
            <img
              className={classes.pictoLogoIfTooFlat}
              src={imgPicto}
              alt="Picto Access"
            />
          )}
        </Link>
      )}
    </Box>
  )
}

export default AccessibilityWidget
